<article class="content-container">
  @defer (when meters()) {
    <app-toolbar size="small">
      @if (!hasMultipleYears) {
        <div class="left">Readings from {{ details.minDate | date: 'MM/dd/yyyy' }}</div>
      }
      <div class="right">
        <app-button size="small" label="Export" icon="mdi mdi-microsoft-excel" size="small" (click)="export()"></app-button>
        @if (hasMultipleYears) {
          <i class="mdi mdi-circle-small divider"></i>
          <app-button size="small" label="Previous Year" icon="mdi mdi-arrow-left" (click)="goBack()" />
          <app-button title="Year displayed" tooltipPosition="left" size="small" [label]="onYear()" [isDisabled]="true"></app-button>
          <app-button size="small" label="Next Year" icon="mdi mdi-arrow-right" iconPos="right" (click)="goForward()" />
        }
      </div>
    </app-toolbar>

    @if (month() !== null) {
      <app-page-title label="{{ monthsFull[month()] }}" [canGoBack]="true" (click)="month.set(null)" />

      @if (metersDaily()) {
        <table class="table table-hover sticky">
          <thead>
            <tr>
              <th>Asset</th>

              @for (day of days(); track $index; let dayIndex = $index) {
                @if (dayIndex > 0) {
                  <th class="text-right">
                    <span class="day-name">{{ dayNames()[$index] }}</span
                    ><br />
                    {{ dayIndex }}
                  </th>
                }
              }
            </tr>
          </thead>
          <tbody>
            @for (asset of metersDaily(); track asset.id) {
              <tr>
                <td>{{ asset.display ?? asset.title }}</td>
                @for (day of days(); track $index; let dayIndex = $index) {
                  @if (dayIndex > 0) {
                    @if (!asset.daily) {
                      <td class="text-right" style="font-size: 8px" title="No Data">x</td>
                    } @else {
                      @if (asset.daily[dayIndex] === null) {
                        <td class="text-right" style="color: #a0a0a0">-</td>
                      } @else {
                        <td class="text-right">
                          {{ asset.daily[dayIndex] | number: '1.0' }}
                        </td>
                      }
                    }
                  }
                }
              </tr>
            }
          </tbody>
        </table>
      }
    } @else {
      <table class="table table-hover sticky">
        <thead>
          <tr>
            <th>Asset</th>
            <th>Site</th>
            @for (month of months; track month; let monthIndex = $index) {
              <th class="text-right can-click" (click)="goToMonth(monthIndex)">{{ month }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (asset of meters(); track asset.id) {
            <tr>
              <td>{{ asset.display ?? asset.title }}</td>
              <td>{{ asset.site_title }}</td>

              @for (month of months; track month; let monthIndex = $index) {
                @if (!asset.months) {
                  <td class="text-right" style="font-size: 8px" title="No Data">x</td>
                } @else {
                  @if (asset.months[monthIndex] === null) {
                    <td class="text-right" style="color: #a0a0a0">-</td>
                  } @else {
                    <td class="text-right" (click)="goToMonth(monthIndex)">
                      {{ asset.months[monthIndex] | number: '1.0' }}
                    </td>
                  }
                }
              }
            </tr>
          }
          <!--
          <tr class="footer">
            <td colspan="2" class="text-left">Total</td>
            @for (total of grandTotals; track $index) {
              <td class="text-right">{{ total | number: '1.0' }}</td>
            }
          </tr>
        --></tbody>
      </table>
      <div class="text-right">
        <i style="color: #a0a0a0; font-size: 10px">Click the month column to drill into the meter daily readings for that month.</i>
      </div>
    }
  } @placeholder {
    <i class="mdi mdi-loading mdi-spin-x2"></i>
  }
</article>
